(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eyre-mavic-product"]) return;
  try {
    
if(!customElements.get('eyre-mavic-page'))customElements.define('eyre-mavic-page',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[data-tab]')];const select=b=>{tabs.forEach(t=>{const active=t===b;t.classList.toggle('active',active);t.setAttribute('aria-selected',active);t.tabIndex=active?0:-1;});this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==b.dataset.tab);};tabs.forEach((b,i)=>{b.addEventListener('click',()=>select(b));b.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(tabs[n]);tabs[n].focus();});});}
});

  } catch(e) { console.error(e); }
})();
})();
